module.exports = __webpack_public_path__ + "img/birthday.475b1f0d.svg";